import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { VeilederStegDefaultProps, VeilederStegBaseProps } from '../../Shared/Scripts/Components/VeilederStegComponent';
import { EpiContext } from '../../Shared/Scripts/Store/EpiContext/Types';
import ForelopigUttalelseSkjemaSideDto from '../Models/ForelopigUttalelseSkjemaSideDto';
import { ForelopigUttalelseSkjemaSideAppState } from '../Store';
import contentResolver, { resolveRawText } from '../../Shared/Scripts/Utilities/EpiContentResolver';
import { setCollapsed } from '../../Shared/Scripts/Store/StegVisning/Actions';
import { StegVisning } from '../../Shared/Scripts/Store/StegVisning/Types';
import * as ValgTypes from '../Store/Valg/Types';
import { ModalCompontent } from '../../Shared/Scripts/Components/ModalComponent';
import { ArticleContentComponent } from '../../Shared/Scripts/Components/ArticleContentComponent';
import { updateLiveMessage } from '../../Shared/Scripts/Utilities/LiveMessage';

type Steg5ComponentOwnProps = VeilederStegDefaultProps & VeilederStegBaseProps & {
    valg: ValgTypes.ValgState,
}

type Steg5DisplayProps = Steg5ComponentOwnProps & MapStateToProps & MapDispatchToProps;

function Steg5ComponentVisning(props: Steg5DisplayProps): JSX.Element {
    const { epiContext } = props;
    
    const [visVilkarAModal, setVisVilkarAModal] = useState(false);

    useEffect(() => {
        updateLiveMessage();
    }, []);

    function onVilkarAClick(): void {
        setVisVilkarAModal(true);
    }

    function onRequestLukkVilkarA(): void {
        setVisVilkarAModal(false);
    }

    function hentDagensDato(): string {
        const now: Date = new Date();
        let date: string = now.getDate() + "";
        let month: string = (now.getMonth() + 1) + "";
        const year: number = now.getFullYear();

        if(date.length === 1)
            date = "0"+date;

        if(month.length === 1)
            month = "0"+month;

        return year + month + date;
    }

    function visLastNedTekst(): void {
        let span: HTMLElement | null = document.getElementById("js-veileder-laster-tekst");
        if(span !== null)
            span.classList.add("c-veileder--nedlastning-vis")
    }

    function skjulLastNedTekst(): void {
        let span: HTMLElement | null = document.getElementById("js-veileder-laster-tekst");
        if(span !== null)
            span.classList.remove("c-veileder--nedlastning-vis")
    }

    function buttonClickHandler(e: React.SyntheticEvent<HTMLButtonElement>): void {
        e.preventDefault();

        visLastNedTekst();

        var request = new XMLHttpRequest();
        request.open('POST', "/api/ForelopigUttalelseSkjemaSide?pageGuid=" + epiContext.epiModel?.contentLink.guidValue, true);
        request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
        request.responseType = 'blob';

        request.onload = function() {

            
        if(request.status === 200) {
            
            var filename = hentDagensDato() +'_preliminary_statement.pdf';
            var blob = new Blob([request.response], { type: 'application/pdf' });

            //for IE11
            let navigator: any = window.navigator;
            if(navigator.msSaveOrOpenBlob) {
                navigator.msSaveOrOpenBlob(blob, filename);
            } else {
                const content = window.URL.createObjectURL(blob);
                window.open(content, filename);
            }
        }
        
        // TODO: legg til feilhåndtering
        skjulLastNedTekst();
        };
        
        let body: string = "Kjonn="+props.valg.brukerInfo?.value.kjonn
                            + "&Navn="+props.valg.brukerInfo?.value.fulltNavn
                            + "&Fodt="+props.valg.brukerInfo?.value.fodt
                            + "&Land="+props.valg.land?.id
                            + "&Helgrad="+props.valg.utdanning?.value
                            + "&Fra="+props.valg.periode?.value.fraAar+"-"+props.valg.periode?.value.fraMaaned+"-01"
                            + "&Til="+props.valg.periode?.value.tilAar+"-"+props.valg.periode?.value.tilMaaned+"-01";

        if(props.valg.brukerInfo?.value.mellom !== null) {
            body = body + "&Mellom="+props.valg.brukerInfo?.value.mellom;
        }   

        request.send(body);
    }
    
    return (
        <div className="c-veileder__panel c-veileder__panel--resultat c-veileder__panel--aubergine">
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--header">
                    <h3 className="c-veileder__tittel c-veileder__tittel--resultat">
                        {props.tittel}
                    </h3>
                </div>
            </div>
            
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content c-veileder__content--textarea">
                    {props.forklaring}
                </div>
                <div className="c-veileder__content c-veileder__content--header c-veileder__content--indented">
                    <button onClick={buttonClickHandler} className="c-knapp c-knapp--cta c-knapp--tertiary">
                        {contentResolver(epiContext, 'steg5Knappetekst')}
                    </button>
                    <span id="js-veileder-laster-tekst" className="c-veileder--nedlastning">{resolveRawText(epiContext, 'steg5VentLastNedTekst')}</span>
                </div>
            </div>
            <div className="c-veileder__panel-row">
                <div className="c-veileder__content">
                    <button type="button" className="c-knapp c-knapp--lenke c-knapp--lenke-aubergine" onClick={onVilkarAClick}>
                        {contentResolver(epiContext, 'steg5VilkaarLenkeTekst')}
                    </button>
                    <ModalCompontent
                        isOpen={visVilkarAModal}
                        onRequestClose={onRequestLukkVilkarA}
                        ariaCloseText={resolveRawText(epiContext, 'steg5VilkaarAriaTekst')}
                    >
                        <ArticleContentComponent
                            headerinnhold={contentResolver(epiContext, 'steg5VilkaarTittel')}
                            contentinnhold={contentResolver(epiContext, 'steg5VilkaarTekst')}
                        />
                    </ModalCompontent>
                </div>
            </div>
        </div>
    )
}

interface MapStateToProps {
    epiContext: EpiContext<ForelopigUttalelseSkjemaSideDto>;
    stegState: StegVisning;
}

interface MapDispatchToProps {
    stegVisningSetCollapsed: typeof setCollapsed;
}

export default connect(
    (state: ForelopigUttalelseSkjemaSideAppState, ownProps: Steg5ComponentOwnProps): MapStateToProps => {
        const stegState = state.stegVisning[ownProps.sporsmalId]
            ? state.stegVisning[ownProps.sporsmalId]
            : { id: ownProps.sporsmalId, isCollapsed: false };
        return {
            stegState,
            epiContext: state.epiContext,
        };
    },
    {
        stegVisningSetCollapsed: setCollapsed,
    },
)(Steg5ComponentVisning);
